import { render } from "./AddNewObject.vue?vue&type=template&id=0fe48646&scoped=true"
import script from "./AddNewObject.vue?vue&type=script&lang=js"
export * from "./AddNewObject.vue?vue&type=script&lang=js"

import "./AddNewObject.vue?vue&type=style&index=0&id=0fe48646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe48646"]])

export default __exports__